module.exports = __webpack_public_path__ + "img/expense_info_hero.9d00a26.png";